<template>
  <div class="menu">

    <carregando-aguarde/>

    <certificar-login 
      ref="certificarLogin"
      @confirmarCertificarLogin="confirmarCertificarLogin"
    />

    <div class="w3-bar w3-top w3-theme w3-large" style="z-index:4">
      <button 
        data-button="menu-paginas" 
        class="w3-bar-item w3-button botao-quadrado w3-hover-none btn-abre-menu" 
        @click="w3_open();">
        
        <span class="w3-white"></span>
        <span class="w3-white"></span>
        <span class="w3-white"></span>
      </button>
      <div 
        data-button="menu-usuario" 
        class="w3-bar-item w3-right w3-dropdown-hover" 
        id="btn-abre-usuario" 
        @click="clickAbaUsuarioMobile();">             

        <img v-if="foto_usuario" 
          style="width: 2rem; height: 2rem; background-size: cover ;align-self: center;" 
          v-bind:src="foto_usuario" 
          class="w3-center w3-circle w3-border"
        />    

        <div class="w3-col s12" v-if="!foto_usuario">
          <div 
            class="circulo-letra w3-border w3-center w3-circle">
            {{getPrimeiraLetraNome(dados_usuario_logado)}}
          </div>
        </div>
      </div>

      <router-link 
        to="/carteira-cliente"
        data-button="menu-paginas" 
        style="padding-bottom: 0px;" 
        v-if="habilitar_gerenciamento_carteiras"
        class="w3-bar-item w3-theme w3-right w3-dropdown-hover">
        <i class="fa fa-wallet"/>
     </router-link>

      <router-link
        to="/principal"
        data-button="menu-paginas" 
        style="padding-bottom: 0px;" 
        class="w3-bar-item w3-theme w3-right w3-dropdown-hover">
        <i class="fa fa-home"/>
      </router-link>  
    </div>
    
    <checar-dispositivo />

    <div 
      class="w3-white w3-border aba-usuario" 
      style="z-index:3; width:300px; display: none; padding: 0" 
      id="usuario">

      <br>

      <div class="w3-margin-bottom" v-cloak>
        <div class="w3-col" v-cloak v-if="dados_usuario_logado">
          <div class="w3-container">
            <div 
              class="w3-panel w3-theme w3-card-2" 
              v-if="!dados_usuario_logado.funcionario_id">
              <p>
                <i class="fa fa-sync-alt w3-spin"></i>
                <span> Processando...</span>
              </p>
            </div>
          </div>

          <div v-if="dados_usuario_logado.funcionario_id">
            <img 
              v-if="foto_usuario" 
              alt="" 
              style="width: 4rem; height: 4rem; background-size: cover; margin-bottom: 15px;" 
              v-bind:src="foto_usuario" 
              class=" w3-center w3-circle w3-border"
            />

            <div v-if="!foto_usuario" class="w3-col s12">
              <div 
                style="width: 70px; height: 70px; font-size: 44px; margin-bottom: 15px;"
                class="circulo-letra-detalhes w3-border w3-center w3-circle">
                {{getPrimeiraLetraNome(dados_usuario_logado)}}
              </div>
            </div>
          </div>

          <div 
            class="w3-col s12 w3-bar" 
            v-if="dados_usuario_logado.funcionario_id">

            <div v-cloak class="texto-preto">
              <strong class="texto-vermelho w3-medium">
                <span>{{dados_usuario_logado.nome}}</span>
              </strong>
            </div>

            <div v-cloak class="texto-preto" style="font-size: 16px; margin-top: 10px;">
              <label class="w3-col">Logado em: </label>
              <strong class="texto-preto w3-medium w3-col"> {{dados_usuario_logado.empresa_logada_id + ' - ' + dados_usuario_logado.empresa_nome_fantasia}} </strong>
            </div>

            <div  
              v-if="Object.keys(empresas_autorizadas).length > 1" 
              class="w3-bar-item w3-button botao-quadrado w3-padding"
              style="width: 100%; text-align: left;">
              <i class="fas fa-building fa-fw w3-text-theme"></i>

              <label 
                @click="mostrar_empresas = !mostrar_empresas"
                style="text-decoration: underline;" 
                class="w3-text-theme">
                <span>Selecionar empresa</span>
              </label>

              <div :style="getClassListaEmpresas()">
                <div
                  :key="empresa.empresa_id"
                  v-show="mostrar_empresas"
                  style="margin-top: 5px;"
                  v-for="empresa in empresas_autorizadas"
                  @click="trocarEmpresa(empresa)"
                  class="w3-btn w3-white w3-border w3-border-theme w3-small w3-padding-small w3-col">
                  <label>{{empresa.empresa_id}} - {{empresa.nome_resumido}}</label>
                </div>
              </div>
            </div>

            <router-link 
              to="/mensagens" 
              style="width: 100%; text-align: left;" 
              class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto w3-medium">
              <i class="fa fa-envelope fa-fw w3-text-theme"></i>
              <strong> Mensagens </strong>
              <strong class="texto-vermelho" v-cloak>({{ quantidade_mensagens }})</strong>
            </router-link>

            <div>
              <div 
                v-bind:key="preview_mensagem.mensagem_id"
                v-for="preview_mensagem in preview_mensagens" 
                style="width: 100%; text-align: left; font-size: 0.8em" 
                class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto div-preview card-item">

                <router-link class="preview-mensagens" to="/mensagens">
                  <div v-if="preview_mensagem.nova == 'S'" class="texto-vermelho" v-cloak>
                    <div class="w3-col s12">
                      <i class="fa fa-envelope fa-fw w3-text-theme" style="margin-left: 2px;"/>
                      <strong style="margin-left: 5px;"> 
                        {{ preview_mensagem.assunto }}
                      </strong>
                    </div>
                    
                    <div class="w3-col s12">
                      <i class="fa fa-comment-dots fa-fw" style="margin-left: 5px; color: #7a7a7a; font-size: 11px;"/>
                      <label style="margin-left: 5px; color: #7a7a7a; font-size: 11px;"> 
                        {{ preview_mensagem.texto }}
                      </label>
                    </div>
                  </div>

                  <div v-if="preview_mensagem.nova != 'S'" class="texto-lido texto-vermelho" v-cloak>
                    <div class="w3-col s12">
                      <i class="fa fa-envelope-open fa-fw" style="margin-left: 2px;"/>
                      <strong style="margin-left: 5px;"> 
                        {{ preview_mensagem.assunto }}
                      </strong>
                    </div>
                    
                    <div class="w3-col s12">
                      <i class="fa fa-comment fa-fw" style="margin-left: 5px; color: #7a7a7a; font-size: 11px;"/>
                      <label style="margin-left: 5px; color: #7a7a7a; font-size: 11px;"> 
                        {{ preview_mensagem.texto }}
                      </label>
                    </div>
                  </div>
                </router-link>
              </div>

              <div class="w3-col s12 w3-center" v-if="existe_mais_mensagens">
                <router-link to="/mensagens">
                  <i style="color: #7a7a7a;" class="w3-button fas fa-ellipsis-h"/>
                </router-link>
              </div>
            </div>

            <button 
              @click="logout" 
              class="w3-bar-item w3-button botao-quadrado w3-padding"
              style="width: 100%; text-align: left;">
              <i class="fa fa-sign-out-alt fa-fw w3-text-theme"></i>
              <label style="font-weight: bold !important;"> Sair</label>
            </button>

          </div>
        </div>
      </div>
    </div>

    <nav 
      class="w3-sidebar w3-animate-left w3-white" 
      style="z-index:3;width:300px;display: none;" 
      id="menu">

      <br>

      <div class="w3-bar-block w3-margin-bottom" v-cloak>
        <router-link
          to="/mensagens"
          @click.native="checarPagina('/mensagens')"
          style="width: 100%; text-align: left;"
          class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto">
          <i class="fa fa-envelope fa-fw w3-text-theme"></i>
          <span> Mensagens </span>
        </router-link>

        <router-link
          data-button="tela-dashboard"
          to="/dashboard"
          @click.native="checarPagina('/dashboard')"
          style="width: 100%; text-align: left;"
          class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto">
          <i class="fa fa-tachometer-alt fa-fw w3-text-theme"></i>
          <span>  Dashboard</span>
        </router-link>

        <div class="link-group">
          <div class="w3-padding margin-0 link-group-title">
            <h5 ><span>Vendas</span></h5>
          </div>

          <div class="router-link-group">
            <router-link
              data-button="tela-controle-gerencial"
              to="/controle-gerencial"
              @click.native="checarPagina('/controle-gerencial')"
              class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto">
              <i class="fa fa-chart-bar fa-fw w3-text-theme"></i>
              <span>  Controle gerencial</span>
            </router-link>

            <router-link
              data-button="tela-vendas-por-vendedor"
              to="/vendas-por-vendedor"
              @click.native="checarPagina('/vendas-por-vendedor')"
              class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto">
              <i class="fa fa-tags fa-fw w3-text-theme"></i>
              <span>  Verificar vendas por vendedor</span>
            </router-link>

            <router-link
              data-button="tela-cancelar-fechamento-pedido"
              to="/cancelar-fechamento-pedido"
              @click.native="checarPagina('/cancelar-fechamento-pedido')"
              class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto">
              <i class="fas fa-reply fa-fw w3-text-theme"></i>
              <span>  Cancelar fechamento pedidos</span>
            </router-link>
          </div>
        </div>

        <div class="link-group">
          <div class="w3-padding margin-0 link-group-title">
            <h5><span>Relatórios</span></h5>
          </div>

          <div class="router-link-group">
            <router-link
              to="/vida-cliente"
              @click.native="checarPagina('/vida-cliente')"
              class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto">
              <i class="fa fa-user-tag fa-fw w3-text-theme"></i>
              <span> Vida do cliente</span>
            </router-link>

            <router-link
              data-button="tela-acompanhamento-vendas"
              to="/acompanhamento-vendas"
              @click.native="checarPagina('/relatorios/acompanhamento-vendas')"
              class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto">
              <i class="fas fa-poll  w3-text-theme"></i>
              <span>  Acompanhamento de vendas</span>
            </router-link>
          </div>
        </div>

        <div class="link-group">
          <div class="w3-padding margin-0 link-group-title">
            <h5><span>Financeiro</span></h5>
          </div>

          <div class="router-link-group">
            <router-link
              data-button="tela-mapa-financeiro"
              to="/mapa-financeiro"
              @click.native="checarPagina('/mapa-financeiro')"
              class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto">
              <i class="fa fa-map fa-fw w3-text-theme"></i>
              <span> Mapa financeiro</span>
            </router-link>

            <router-link
              data-button="tela-afericao-lucro"
              v-if="usuario_santri == 'S'"
              to="/afericao-lucro"
              @click.native="checarPagina('/afericao-lucro')"
              class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto">
              <i class="fas fa-chart-line w3-text-theme"></i>
              <span>  Aferição do lucro</span>
            </router-link>

            <router-link
              data-button="tela-afericao-lucro"
              v-if="usuario_santri == 'S'"
              to="/afericao-lucro2"
              @click.native="checarPagina('/afericao-lucro2')"
              class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto">
              <i class="fas fa-chart-line w3-text-theme"></i>
              <span>  Aferição do lucro 2</span>
            </router-link>

            <router-link
              data-button="tela-visoes-financeiras"
              v-if="usuario_santri == 'S'"
              to="/visoes-financeiras"
              @click.native="checarPagina('/visoes-financeiras')"
              class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto">
              <i class="fas fa-dollar-sign  w3-text-theme"></i>
              <span>  Visões financeiras</span>
            </router-link>
          </div>
        </div>

        <div class="w3-padding margin-0">
          <h5><span>Cadastros e outros</span></h5>
        </div>

        <router-link
          data-button="tela-clientes-simplificados"
          to="/clientes-simplificados"
          @click.native="checarPagina('/clientes-simplificados')"
          class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto">
          <i class="fa fa-address-card fa-fw w3-text-theme"></i>
          <span> Clientes simplificados</span>
        </router-link>

        <router-link
          data-button="tela-verificar-patrimonio"
          to="/verificar-patrimonio"
          @click.native="checarPagina('/verificar-patrimonio')"
          class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto">
          <i class="fa fa-building fa-fw w3-text-theme"></i>
          <span> Verificar patrimônio</span>
        </router-link>

        <router-link
          data-button="tela-gerenciamento_sugestoes"
          to="/gerenciamento_sugestoes"
          @click.native="checarPagina('/gerenciamento_sugestoes')"
          class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto"
          style='display: none'>
          <i class="fa fa-comment fa-fw w3-text-theme"></i>
          <span>  Gerenciar sugestões</span>
        </router-link>

        <div class="w3-padding margin-0">
          <h5>Estoque</h5>
        </div>

        <router-link
          data-button="tela-confirmar-saida-produtos"
          to="/confirmar-saida-produtos"
          @click.native="checarPagina('/confirmar-saida-produtos')"
          class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto">
          <i class="fas fa-sign-out-alt fa-fw w3-text-theme"></i>
          <span>  Confirmar saída de produtos</span>
        </router-link>

        <router-link
          data-button="tela-manifestos"
          to="/manifestos"
          @click.native="checarPagina('/manifestos')"
          class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto">
          <i class="fa fa-truck fa-fw w3-text-theme"></i>
          <span>  Manifestos</span>
        </router-link>

        <router-link
          data-button="tela-contagens-estoque"
          to="/contagens-estoque"
          @click.native="checarPagina('/contagens-estoque')"
          class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto">
          <i class="fa fa-th-list fa-fw w3-text-theme"></i>
          <span>  Inventário</span>
        </router-link>

        <div class="w3-padding margin-0">
          <h5>Configurações</h5>
        </div>

        <router-link
          data-button="tela-gerenciar-sugestoes"
          to="/gerenciar-sugestoes"
          @click.native="checarPagina('/gerenciar-sugestoes')"
          class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto">
          <i class="far fa-comment fa-fw w3-text-theme"></i>
          <span>  Gerenciar sugestões</span>
        </router-link>

        <router-link
          v-if="false"
          data-button="logs-admservicos"
          to="/logs/logs-admservicos" @click.native="checarPagina('/logs-admservicos')"
          class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto">
          <i class="fas fa-exclamation-triangle w3-text-theme"></i>
          <span>  Logs do dispositivo</span>
        </router-link>

        <router-link
          data-button="logs-erros"
          v-if="mostrar_logs_servidor"
          to="/logs/logs-servidor" @click.native="checarPagina('/logs-servidor')"
          class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto">
          <i class="fa fa-code w3-text-theme"></i>
          <span>  Logs de servidor/sessão</span>
        </router-link>

        <router-link
          data-button="acessos-admweb"
          to="/acessos-admweb" @click.native="checarPagina('/acessos-admweb')"
          class="w3-bar-item w3-button botao-quadrado w3-padding texto-preto">
          <i class="fa fa-user-clock w3-text-theme"></i>
          <span>  Acessos do ADMWeb</span>
        </router-link>

        <br>
        <br>

      </div>
    </nav>

    <div
      class="w3-overlay w3-animate-opacity"
      @click="w3_close()"
      style="cursor:pointer"
      id="myOverlay">
    </div>
  </div>
</template>

<script>
  import toastr from 'toastr'
  import store from '@/ambiente/store'
  import RSessao from '@/components/Rest/RSessao'
  import RMensagem from '@/components/Rest/RMensagem'
  import RLogout from '@/components/Rest/RLogout.js'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  import ChecarDispositivo from '@/components/ChecarDispositivo'
  import CarregandoAguarde from '@/components/CarregandoAguarde'
  import CertificarLogin from '@/components/CertificarLogin'
  
  export default {
    name: 'Menu',

    components: {
      ChecarDispositivo,
      CarregandoAguarde,
      CertificarLogin
    },

    data() {
      return {
        quantidade_mensagens: 0,
        ultima_busca: 0,
        preview_mensagens: [],
        usuario_santri: 'N',
        foto_usuario: undefined,
        dados_usuario_logado: undefined,
        habilitar_gerenciamento_carteiras: false,
        status_aba_login: false,
        status_aba_menu: false,
        empresas_autorizadas: [],
        mostrar_empresas: false,
        mostrar_logs_servidor: false,
        existe_mais_mensagens: false,
        certificarLoginAberto: false
      }
    },

    watch: {
      status_aba_login() {
        this.verificarModalAberto()
      },

      status_aba_menu() {
        this.verificarModalAberto()
      }
    },

    computed: {
      verificarModal() {
        if (this.status_aba_login || this.status_aba_menu) {
          return true;
        }
        else {
          return false
        }
      },
    },

    created() {      
      let htmlTag = document.getElementsByTagName('html')[0];

      if (htmlTag.classList.contains('modal-aberto')) {
        htmlTag.classList.remove('modal-aberto');
      }
    },

    async mounted() {
      await this.buscarDadosStore(!RSessao.carregouSessao());
      await this.verificarSessaoExpirada();

      setInterval(async () => {
          await this.verificarSessaoExpirada();
        }, 
        3000
      );
    },

    methods: {
      async verificarSessaoExpirada(){
        try {
          let dados_sessao_usuario = await RSessao.getDadosSessaoUsuario();
          dados_sessao_usuario = await JSON.parse(JSON.stringify(dados_sessao_usuario));

          if 
            (
              (!this.certificarLoginAberto) &&
              (dados_sessao_usuario.usuario_id) &&
              (dados_sessao_usuario.exigir_certificacao_login == 'S')
            )
          {
            this.certificarLoginAberto = true;
            swal("É necessário realizar o login para concluir esta operação!");
            this.$refs.certificarLogin.abrir();
          }
        } catch (error) {
          // Fazer nada.
        }
      },

      async trocarEmpresa(empresa) {
        try {
          let parametros = {
            empresa_id : empresa.empresa_id
          }

          let retorno = await RSessao.trocarEmpresa(this.axios, parametros);

          if (retorno.houve_erro == 'S') {
            throw new Error(retorno.mensagem);
          }

          toastr.info('Empresa ' + empresa.nome_resumido + ' selecionada com sucesso.');

          this.buscar_dados_sessao = true;
          await RSessao.buscarDadosCarregarSessao(this.axios);
          await this.buscarDadosStore(true);
          
          window.location.href = '/principal';
        }
        catch (e) {
          toastr.info('Não foi possível trocar de empresa! ' + e.message);
        }
      },

      confirmarCertificarLogin(){
        this.certificarLoginAberto = false;
      },

      async buscarDadosStore(buscar_dados_sessao){
        if (buscar_dados_sessao) {
          await RSessao.buscarDadosCarregarSessao(this.axios);
        }

        this.dados_usuario_logado = await JSON.parse(
          JSON.stringify(store.state.usuario_logado)
        );

        this.empresas_autorizadas = [];
        if(store.state.empresas_autorizadas){
          let empresas = await JSON.parse(JSON.stringify(store.state.empresas_autorizadas));
          for (let i = 0; i < empresas.length; i++) {
            if(empresas[i].autorizado == "S"){
              this.empresas_autorizadas.push(empresas[i]);
            }
            
          }
        }
        this.dados_usuario_logado.empresa_nome_fantasia = await JSON.parse(
          JSON.stringify(store.state.empresa_logada.nome_fantasia)
        );

        this.dados_usuario_logado.empresa_logada_id = await JSON.parse(
          JSON.stringify(store.state.empresa_logada.empresa_id)
        );
      
        this.foto_usuario = '';
        if (store.state.foto_usuario_logado) {
          let dados_foto = await JSON.parse(JSON.stringify(store.state.foto_usuario_logado));
          if (dados_foto.foto) {
            this.foto_usuario = 'data:image/jpeg;base64,' + dados_foto.foto;
          }
        }

        this.habilitar_gerenciamento_carteiras = (await store.state.usuario_logado.utiliza_gerenciamento_carteiras == 'S' ? true : false);

        if (RSessao.eUsuarioGerente()) {
          this.usuario_santri = 'S';
        }
        else {
          this.usuario_santri = 'N';
        }

        try {
          this.mostrar_logs_servidor = 
          (
            (Biblioteca.valorInt(store.state.foto_usuario_logado.funcionario_id) == Biblioteca.valorInt(store.state.parametros_gerais.usuario_santri_id)) ||
            (store.state.parametros_gerais.treinamento == 'S')
          );
        } catch (error) {
          this.mostrar_logs_servidor = false;
        }
      },
      
      getClassListaEmpresas() {
        if (!this.mostrar_empresas) {
          return '';
        }

        if (this.empresas_autorizadas.length < 5) {
          return 'overflow: auto; height: 200px;';
        }
        else if (this.empresas_autorizadas.length > 5) {
          return 'overflow-y: scroll; height: 200px;';
        }
      },
      
      verificarModalAberto() {
        const el = document.documentElement;

        if (this.verificarModal) {
          el.classList.add('modal-aberto');
        }
        else {
          el.classList.remove('modal-aberto');
        }
      },

      checarPagina(urlAtual) {
        this.status_aba_menu = false;

        if (this.$route.path == '/nao-autorizado') {
          this.w3_close();
        }

        if (this.$route.path == urlAtual){
          this.$router.go(this.$route.path);
        }
      },

      async logout(){
        try {
          await RLogout.realizarLogout(this.axios);
          window.location.href = '/login';
        } catch (error) {
          console.log('Erro ao realizar logout: ' + JSON.stringify(error));
        }
      },

      async buscarUsuarioLogado(){                  
        if (
          this.$route.path == '/configuracoes' || 
          this.$route.path == '/configuracoes-financeiro' || 
          this.$route.path == '/dashboard'
        ) {
          this.$root.$emit('usuario_logado', dados_usuario_logado.funcionario_id);
        }        
      },

      retornoUsuarioLogado(){
        return store.state.dados_usuario_logado.funcionario_id;
      },

      async buscarDadosAbaUsuario() {
        if (
          (!store.state.dados_usuario_logado) || 
          (!store.state.dados_usuario_logado.funcionario_id) || 
          (Math.abs(Date.now() - this.ultima_busca) > 60000)
        ){
          this.ultima_busca = Date.now();          
          let retorno = await RMensagem.buscarMensagensUsuario(this.axios, 3);
          if (retorno.houve_erro == 'S') {
            this.quantidade_mensagens = 0;
            this.preview_mensagens = [];
            
            return;
          }

          // Quantidade de mensagens
          this.quantidade_mensagens = retorno.dados.data.mensagens.length;

          // Preview mensagens
          this.preview_mensagens = [];
          this.existe_mais_mensagens = false;
          if (retorno.dados.data.mensagens.length > 3){
            this.existe_mais_mensagens = true;
            for (let i = 0; i < 3; i++){
              this.preview_mensagens.push(retorno.dados.data.mensagens[i]);
            }
          } else{
            this.preview_mensagens = retorno.dados.data.mensagens;
          }

          // Tratamento assunto e mensagem
          for (let i = 0; i < this.preview_mensagens.length; i++){
            this.preview_mensagens[i].assunto = this.preview_mensagens[i].assunto.replace(/\\n/g, String.fromCharCode(13) + String.fromCharCode(10));
            this.preview_mensagens[i].texto = this.preview_mensagens[i].texto.replace(/\\n/g, String.fromCharCode(13) + String.fromCharCode(10));

            if (this.preview_mensagens[i].assunto.length > 35){
              this.preview_mensagens[i].assunto = this.preview_mensagens[i].assunto.substring(0, 35) + '..';
            }

            if (this.preview_mensagens[i].texto.length > 35){
              this.preview_mensagens[i].texto = this.preview_mensagens[i].texto.substring(0, 35) + '..';
            } 
          }
        }
      },
      
      w3_open() {
        this.fecharAbaUsuarioDesk();
        
        var mySidebar = document.getElementById('menu');
        var overlayBg = document.getElementById('myOverlay');
        var btnMenu = document.querySelector('.btn-abre-menu');

        if (mySidebar.style.display == 'block') {
          mySidebar.style.display = 'none';
          overlayBg.style.display = 'none';
          btnMenu.classList.remove('open');
          this.status_aba_menu = false;
        }
        else {
          mySidebar.style.display = 'block';
          overlayBg.style.display = 'block';
          btnMenu.classList.add('open');
          this.status_aba_menu = true;
        }
      },

      w3_close: function () {
        var mySidebar = document.getElementById('menu');
        var overlayBg = document.getElementById('myOverlay');
        var btnMenu = document.querySelector('.btn-abre-menu');
        mySidebar.style.display = 'none';
        overlayBg.style.display = 'none';
        btnMenu.classList.remove('open');

        this.fecharAbaUsuarioMobile();
      },

      fecharAbaUsuarioDesk() {
        document.getElementById('usuario').style.display = 'none';
      },

      abrirAbaUsuarioDesk() {
        document.getElementById('usuario').style.display = 'block';
      },

      fecharAbaUsuarioMobile() {
        document.getElementById('usuario').style.display = 'none';
        document.getElementById('myOverlay').style.display = 'none';
        this.status_aba_login = false;
        this.status_aba_menu = false;
      },

      async buscarDadosUsuarioStore(){
        return await store.state.dados_usuario_logado;
      },

      async clickAbaUsuarioMobile() {
        var usuarioContent = document.getElementById('usuario');
        var overlayBg = document.getElementById('myOverlay');
        var btnMenuUsuario = document.getElementById('btn-abre-usuario');

        var btnAbreMenu = document.querySelector('.btn-abre-menu')
        var menuContent = document.getElementById('menu')

        if (menuContent.style.display == 'block') {
          menuContent.style.display = 'none';
          btnAbreMenu.classList.remove('open');
        }

        if (usuarioContent.style.display == 'block') {
          usuarioContent.style.display = 'none';
          overlayBg.style.display = 'none';
          btnMenuUsuario.classList.remove('open');
        }
        else {
          usuarioContent.style.display = 'block';
          overlayBg.style.display = 'block';
          btnMenuUsuario.classList.add('open');
        }

        this.buscarDadosAbaUsuario();
        this.status_aba_login = true;
      },
      
      getStyleBackGroundImage(){         
        return "background-image: url('" + this.foto_usuario.toString() + "');";
      },

      getPrimeiraLetraNome(dados_usuario_logado){
        if ((dados_usuario_logado) && (dados_usuario_logado.nome)){
          return dados_usuario_logado.nome.substr(0, 1);
        } else {
          return '?';
        }
      },
    }
  }
</script>

<style scoped>
  .menu{
    margin-top: 40px;
  }

  .btn-abre-menu {
    width: 29px;
    height: 25px;
    position: absolute;
    top: 15px;
    left: 10px;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .5s ease-in-out;
    -moz-transition: .5s ease-in-out;
    -o-transition: .5s ease-in-out;
    transition: .5s ease-in-out;
    cursor: pointer;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    outline: none !important
  }

  .btn-abre-menu span {
    display: block;
    position: absolute;
    height: 2px;
    width: 21px;
    background: #9c1d1c;
    border-radius: 9px;
    opacity: 1;
    left: 0;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .25s ease-in-out;
    -moz-transition: .25s ease-in-out;
    -o-transition: .25s ease-in-out;
    transition: .25s ease-in-out;
  }

  .btn-abre-menu span:nth-child(1) {
    top: 0px;
    -webkit-transform-origin: left center;
    -moz-transform-origin: left center;
    -o-transform-origin: left center;
    transform-origin: left center;
  }

  .btn-abre-menu span:nth-child(2) {
    top: 6px;
    -webkit-transform-origin: left center;
    -moz-transform-origin: left center;
    -o-transform-origin: left center;
    transform-origin: left center;
  }

  .btn-abre-menu span:nth-child(3) {
    top: 12px;
    -webkit-transform-origin: left center;
    -moz-transform-origin: left center;
    -o-transform-origin: left center;
    transform-origin: left center;
  }

  .btn-abre-menu.open span:nth-child(1) {
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
    top: -1px;
    left: 2px;
  }

  .btn-abre-menu.open span:nth-child(2) {
    width: 0%;
    opacity: 0;
  }

  .btn-abre-menu.open span:nth-child(3) {
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg);
    top: 14px;
    left: 2px;
  }
  
  .preview-mensagens {
    text-decoration: none;
  }

  .container-preview {
    background-color:#e6e6e6
  }

  .div-preview {
    border-bottom: 1px solid white
  }
  .texto-lido {
    color: rgb(39, 39, 39)
  }

  .menu h5 {
    border-bottom: 1px solid #000;
  }
  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #ddd;
  }

  ::-webkit-scrollbar-thumb {
    background: #8d1007;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #9c1d1c;
  }

  @media screen and (min-width: 1180px){
    #menu a:hover{background-color: #ddd !important;}
  }

  .aba-usuario {
    width: 300px;
    position: fixed;
    right: 0;
    top: 45px;
    padding: 20px 20px 10px;
    text-align: center;
  }

  .circulo-letra {
    width: 30px; 
    height: 30px; 
    background-color: #f7f7f7; 
    color: #9c1d1c; 
    background-size: cover; 
    font-weight: bold; 
    font-size: 17px; 
    display: inline-block; 
    padding-top: 1px;
    border: 2px solid #ebe6e6!important; 
    box-shadow: #6b6b6b 2px 2px 5px 2px;
  }

  .circulo-letra-detalhes {
    width: 30px; 
    height: 30px; 
    background-color: #ac5555; 
    color: #f7f7f7; 
    background-size: cover; 
    font-weight: bold; 
    font-size: 17px; 
    display: inline-block; 
    padding-top: 1px;
    border: 3px solid #ebe6e6!important; 
    box-shadow: #6b6b6b 2px 2px 5px 2px;
  }

  .card-item {
    background: white;
    border-radius: 30px !important;
    margin-bottom: 5px;
    margin-left: 20px !important;
    margin-right: 20px !important;
    padding: 5px !important;
    border: 2px solid rgb(172, 168, 168);
    background-color: #f7f7f7 !important; 
    cursor: pointer;
    font-size: 12px !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/Menu.vue